import { evaluateFlag } from '@nohara-dxdev/feature-flags';
import {
  constructOrgTargetId,
  constructOrgUserTargetId,
  FEATURE_FLAGS,
  type FeatureFlagKey,
  TARGET_ORG,
  TARGET_ORG_USER,
} from '@nohara-dxdev/mt-common';
import { useOidc, useScopeIds } from '@nohara-dxdev/react-oidc';

import { useFeatureFlagsMe } from '../api/get-feature-flags';

export interface UseFeatureFlagResult {
  enabled: boolean;
  isLoading: boolean;
  isError: boolean;
}

export const useFeatureFlag = (flagKey: FeatureFlagKey): UseFeatureFlagResult => {
  const context = useScopeIds();
  const { orgId } = context;
  const { userId } = useOidc();
  const query = useFeatureFlagsMe();

  if (!orgId || !userId) {
    return { enabled: false, isLoading: true, isError: false };
  }
  if (query.isError) {
    return { enabled: false, isLoading: false, isError: true };
  }
  if (query.isLoading || !query.data) {
    return { enabled: false, isLoading: true, isError: false };
  }
  const def = FEATURE_FLAGS[flagKey];
  const target = {
    [TARGET_ORG]: constructOrgTargetId(orgId),
    [TARGET_ORG_USER]: constructOrgUserTargetId(orgId, userId),
  };
  return {
    enabled: evaluateFlag(def, target, query.data.flags),
    isLoading: false,
    isError: false,
  };
};
